import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { TableIcon24Regular } from "../../../../../icons2022/FileTypeTableIcon/TableIcon24Regular";
import { TableIcon32Regular } from "../../../../../icons2022/FileTypeTableIcon/TableIcon32Regular";
import { TableIcon64Regular } from "../../../../../icons2022/FileTypeTableIcon/TableIcon64Regular";
export var TableIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(TableIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(TableIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(TableIcon64Regular, null);
  }
}, 'TableIcon');